import React, { useState, useEffect } from "react";
import { useInView } from "./ProductDetail130";
import "./ProductDetail129.css";

/* ════════════════════════════════
   USE CASES
════════════════════════════════ */
const USE_CASES = [
  {
    icon: "bi-sign-merge-right-fill",
    title: "National Highways",
    tag: "NHAI / MoRTH",
    desc: "Full ANPR + FASTag automation across NHAI-managed highway corridors with centralized audit compliance and real-time revenue tracking.",
    img: "ImagesNew/feature-detection-LR.jpeg",
    color: "#0284c7",
    bg: "#e0f2fe",
    points: ["NHAI Compliant", "Real-time revenue sync", "Multi-lane support"],
  },
  {
    icon: "bi-building-fill",
    title: "Smart Cities",
    tag: "Urban Infrastructure",
    desc: "Integrated urban toll monitoring feeding real-time traffic data directly into smart city management systems for better flow control.",
    img: "ImagesNew/Hero-Image-2-LR.png",
    color: "#6d28d9",
    bg: "#ede9fe",
    points: ["Smart city integration", "Traffic flow data", "Live dashboards"],
  },
  {
    icon: "bi-briefcase-fill",
    title: "Private Toll Operators",
    tag: "BOT / HAM Models",
    desc: "Revenue assurance and fraud prevention built for privately operated toll concessions — covering BOT, HAM, and OMT contract models.",
    img: "ImagesNew/feature-monitoring3.jpeg",
    color: "#0f766e",
    bg: "#ccfbf1",
    points: ["Revenue protection", "Fraud prevention", "Operator portal"],
  },
  {
    icon: "bi-bank2",
    title: "Government Monitoring",
    tag: "Audit & Compliance",
    desc: "Independent AI audit layer for government bodies to verify toll collection performance, compliance reports, and operator accountability.",
    img: "ImagesNew/dashboard-LR-1.jpeg",
    color: "#b45309",
    bg: "#fef3c7",
    points: ["Compliance reports", "Audit-ready data", "Third-party access"],
  },
];

function ProductDetail132() {
  const [active, setActive] = useState(0);
  const [secRef, inView] = useInView(0.08);

  useEffect(() => {
    const id = setInterval(() => setActive(s => (s + 1) % USE_CASES.length), 3500);
    return () => clearInterval(id);
  }, []);

  const uc = USE_CASES[active];

  return (
    <section className="pd9-usecases" ref={secRef}>
      <div className="pd9-blob pd9-blob--tr" />
      <div className="pd9-blob pd9-blob--bl" />
      <div className="pd9-wrap">

        <div className={`pd9-head ${inView ? "pd9-head--in" : ""}`}>
          <span className="pd9-eyebrow">USE CASES</span>
          <h2 className="pd9-h2">Who Uses TPMS? <span>Industries We Serve</span></h2>
          <p className="pd9-sub">From national highways to smart cities — TPMS adapts to every infrastructure model.</p>
        </div>

        {/* Tab buttons */}
        <div className="pd9-uc-tabs">
          {USE_CASES.map((u, i) => (
            <button
              key={i}
              className={`pd9-uc-tab ${active === i ? "pd9-uc-tab--on" : ""}`}
              style={{ "--tc": u.color, "--tb": u.bg }}
              onClick={() => setActive(i)}
            >
              <i className={`bi ${u.icon}`} />
              <span>{u.title}</span>
            </button>
          ))}
        </div>

        {/* Active panel */}
        <div
          className={`pd9-uc-panel ${inView ? "pd9-uc-panel--in" : ""}`}
          key={active}
          style={{ "--tc": uc.color, "--tb": uc.bg }}
        >
          {/* Left: image */}
          <div className="pd9-uc-panel__img-wrap">
            <img src={uc.img} alt={uc.title} loading="lazy" />
            <div className="pd9-uc-panel__img-fade" />
            <div className="pd9-uc-panel__tag" style={{ background: uc.color }}>
              <i className={`bi ${uc.icon}`} /> {uc.tag}
            </div>
          </div>

          {/* Right: content */}
          <div className="pd9-uc-panel__body">
            <div className="pd9-uc-panel__icon" style={{ background: uc.bg, color: uc.color }}>
              <i className={`bi ${uc.icon}`} />
            </div>
            <h3 className="pd9-uc-panel__title">{uc.title}</h3>
            <p className="pd9-uc-panel__desc">{uc.desc}</p>

            <ul className="pd9-uc-panel__points">
              {uc.points.map((pt, j) => (
                <li key={j} style={{ "--tc": uc.color }}>
                  <i className="bi bi-check2-circle" />
                  {pt}
                </li>
              ))}
            </ul>

            <a href="/contact-us" className="pd9-btn" style={{ "--bc": uc.color, "--bb": uc.bg }}>
              Learn More <i className="bi bi-arrow-right" />
            </a>
          </div>
        </div>

        {/* Dot indicators */}
        <div className="pd9-uc-dots">
          {USE_CASES.map((u, i) => (
            <button
              key={i}
              className={`pd9-uc-dot ${active === i ? "pd9-uc-dot--on" : ""}`}
              style={{ "--tc": u.color }}
              onClick={() => setActive(i)}
            />
          ))}
        </div>

      </div>
    </section>
  );
}
export default ProductDetail132;